import { FC } from 'react'
import { AdditionalServicesInvoicePreview } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesInvoicePreviewPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesInvoicePreview />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesInvoicePreviewPage
